export default "__VITE_ASSET__Bd2wsb1G__"